import {useEffect, useState} from 'react';
import {_settings} from '../../configuration/index.config';

interface IToggle {
    className:string,
    title:string,
    color:string
}
const useGlobalToggles = () => {
    const [togglesList, setTogglesList] = useState<IToggle[]>([]);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [timeOutId, setTimeOutId] = useState<any>(null);
    const [isClose, setIsClose] = useState(false);
    const [activeTimer, setTimer] = useState(false);

    /**
     * close - close toggle
     */
    const close = () => {
        const copyTogglesList:IToggle[] = JSON.parse(JSON.stringify(togglesList));

        timeOutId && clearTimeout(timeOutId);
        setTimeOutId(null);
        copyTogglesList.splice(0, 1);
        setTogglesList(copyTogglesList);
        if (copyTogglesList.length === 0) {
            setActiveIndex(-1);
        } else {
            setActiveIndex(-1);
            setActiveIndex(0);
            setTimer(true);
        }
        setIsClose(false);
    };

    /**
     * addToTogglesList - add new toggle to list
     * @param color - toggle color
     * @param title - toggle title
     */
    const addToTogglesList = (color, title) => {
        const toggle = {className: 'small-warning-fixed', title, color};

        setTogglesList((toggleArray) => ([
            ...toggleArray,
            toggle
        ]));

        activeIndex === -1 && setActiveIndex(0);
        !timeOutId && setTimer(true);
    };

    useEffect(() => () => {
        timeOutId && clearTimeout(timeOutId);
        setTimeOutId(null);
        setTogglesList([]);
        setActiveIndex(-1);
    }, []);

    useEffect(() => {
        isClose && close();
    }, [isClose]);

    useEffect(() => {
        if (activeTimer && !timeOutId) {
            const id = setTimeout(() => {
                setIsClose(true);
            }, _settings.timers.TOGGLE_TIMEOUT);

            setTimeOutId(id);
            setTimer(false);
        }
    }, [activeTimer, timeOutId]);

    return {
        addToTogglesList,
        activeIndexToggle: activeIndex,
        togglesList,
        closeToggle: close
    };
};

export default useGlobalToggles;
